export enum TransactionType {
  EFT = 'EFT',
  ACH = 'ACH',
}
